"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawUtil = void 0;
const ltentity_1 = require("../../../../cadplugins/cad/ltentity");
const ltpoint_1 = require("../../../../cadplugins/cad/ltpoint");
const ltfeature_1 = require("../../../../cadplugins/data/ltfeature");
const ltfields_1 = require("../../../../cadplugins/data/ltfields");
const sprinklerutils_1 = require("../../../sprinkler/sprinklerutils");
const pipeNode_1 = require("../../pipeNode");
const pipeSizeTextDrawer_1 = require("../../pipeSizeTextDrawer");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const drawInfo_1 = require("./drawInfo");
class DrawUtil {
    static GetDrawInfo(rootNode, mainPipeLayer, childPipeLayer, pipeDozzleLayer, pipeDiameterTextLayer, pipeSizeMap, sprinklerSettingMethod, drawscale, riserName, cadMap) {
        let drawInfo = new drawInfo_1.DrawInfo();
        this.traverseDrawLineAndText(rootNode, mainPipeLayer, childPipeLayer, pipeDozzleLayer, pipeDiameterTextLayer, pipeSizeMap, sprinklerSettingMethod, drawscale, riserName, cadMap, drawInfo);
        return drawInfo;
    }
    static traverseDrawLineAndText(node, mainPipeLayer, childPipeLayer, pipeDozzleLayer, pipeDiameterTextLayer, pipeSizeMap, sprinklerSettingMethod, drawscale, riserName, cadMap, drawInfo) {
        //绘制管点
        for (let child of node._children) {
            let pipeCount = child.computeChildrenNodes();
            if (child._type == pipeNode_1.PipeNodeType.Child) { //如果child节点是喷头，则需要加上它本身
                pipeCount++;
            }
            let text = pipeSizeMap.getPipeSizeStr(pipeCount);
            let line = new ltentity_1.LTLine(new ltpoint_1.LTPoint(node._point.x, node._point.y), new ltpoint_1.LTPoint(child._point.x, child._point.y));
            let lineFeature = new ltfeature_1.LTFeature({
                geometry: line,
                layer: node._type == pipeNode_1.PipeNodeType.Main && child._type == pipeNode_1.PipeNodeType.Main ? mainPipeLayer : childPipeLayer,
                xdata: JSON.stringify({
                    pipeSize: text,
                    source: "autoGenerate",
                }),
            });
            lineFeature.setValue(ltfields_1.FieldNames.EntityLayer, lineFeature.layer.name);
            lineFeature.setValue(ltfields_1.FieldNames.Color, ltentity_1.dwg_bylayer);
            lineFeature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
            lineFeature.setValue(ltfields_1.FieldNames.Width, 0.0);
            lineFeature.setValue(ltfields_1.FieldNames.Rotate, 0.0);
            //cadMap.addFeature(lineFeature);
            drawInfo._pipeLineFeatures.push(lineFeature);
            let ltText = pipeSizeTextDrawer_1.PipeSizeTextDrawer.getLTText(line.getStart(), line.getEnd(), text, drawscale);
            //构建管径文字要素
            let textFeature = new ltfeature_1.LTFeature({
                geometry: ltText,
                layer: pipeDiameterTextLayer,
                xdata: JSON.stringify({
                    source: "autoGenerate",
                }),
            });
            textFeature.setValue(ltfields_1.FieldNames.EntityLayer, textFeature.layer.name);
            textFeature.setValue(ltfields_1.FieldNames.EntityType, "AcDbText");
            textFeature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
            //cadMap.addFeature(textFeature);
            drawInfo._textFeatures.push(textFeature);
            if (child._type == pipeNode_1.PipeNodeType.Child) { //绘制喷头
                this.addSprinklerToLayer(new ltpoint_1.LTPoint(child._point.x, child._point.y), child._id, pipeDozzleLayer, sprinklerSettingMethod, drawscale, cadMap, drawInfo);
            }
            else if (child._type == pipeNode_1.PipeNodeType.Valve) { //绘制试水阀
                let pos = new ltpoint_1.LTPoint(child._point.x, child._point.y);
                let valve_block = new ltentity_1.LTEntityPoint(pos);
                valve_block.setRotate(new LineSegment_js_1.default(node._point, child._point).angle());
                valve_block.blockName = sprinklerutils_1.BLOCK_DEADLINE;
                valve_block.scale(new ltpoint_1.LTPoint(drawscale, drawscale), pos);
                let feature = new ltfeature_1.LTFeature({
                    geometry: valve_block,
                    layer: childPipeLayer,
                    xdata: JSON.stringify({
                        source: "autoGenerate",
                        id: child._id,
                        riser_name: riserName
                    }),
                });
                feature.setValue(ltfields_1.FieldNames.EntityLayer, feature.layer.name);
                feature.setValue(ltfields_1.FieldNames.Color, ltentity_1.dwg_bylayer);
                feature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
                feature.setValue(ltfields_1.FieldNames.Width, 0.0);
                //cadMap.addFeature(feature);
                drawInfo._valveFeatures.push(feature);
            }
            this.traverseDrawLineAndText(child, mainPipeLayer, childPipeLayer, pipeDozzleLayer, pipeDiameterTextLayer, pipeSizeMap, sprinklerSettingMethod, drawscale, riserName, cadMap, drawInfo);
        }
    }
    static addSprinklerToLayer(pos, nodeId, layer, sprinklerSettingMethod, drawscale, cadMap, drawInfo) {
        let block = new ltentity_1.LTEntityPoint(pos);
        block.blockName = sprinklerSettingMethod;
        block.scale(new ltpoint_1.LTPoint(drawscale, drawscale), pos);
        let feature = new ltfeature_1.LTFeature({
            geometry: block,
            layer: layer,
            xdata: JSON.stringify({
                source: "autoGenerate",
                id: nodeId
            }),
        });
        feature.setValue(ltfields_1.FieldNames.EntityLayer, feature.layer.name);
        feature.setValue(ltfields_1.FieldNames.Color, ltentity_1.dwg_bylayer);
        feature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
        feature.setValue(ltfields_1.FieldNames.Width, 0.0);
        //cadMap.addFeature(feature);
        drawInfo._pipePointFeatures.push(feature);
    }
}
exports.DrawUtil = DrawUtil;
